import { IScreening } from '../types'
import { allergyTranslateEngToPt } from '../utils/allergyResponseParser'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const filterScreeningPayloadFromStep = (step: string, data: IScreening) => {
  switch (step) {
    case 'DADOS_CADASTRO':
      return {
        dadosPessoaisTriagem: {
          celular: data.patient?.cellphone,
          email: data.patient?.email,
          endereco: data.patient?.address,
        },
      }
    case 'SINTOMAS':
      return {
        sintomaTriagem: {
          sintomas: data.symptons?.symptons?.map(i => ({
            descricao: i.description,
            id: i.id,
          })),
          sintomasEvidentes: data.symptons?.hardSymptons?.map(
            i => i.description,
          ),
          intensidadeSintomas: data.symptons?.intensity?.toUpperCase(),
        },
      }
    case 'DOENCAS_CRONICAS_MEDICAMENTOS':
      return {
        doencaMedicamentoTriagem: {
          doencas: data.diseases?.map(i => ({
            id: i.id,
            descricao: i.description,
          })),
          medicamentos: data.medicines?.map(i => ({
            medicamentoId: i.id,
            dose: i.quantity,
            descricao: i.description,
          })),
        },
      }
    case 'ALERGIAS_MEDICAMENTO':
      return {
        alergiaTriagem: {
          alergiasMedicamentos: data.allergies.medicines?.map(i => ({
            codigoPrincipioAtivo: i.id,
            alergia: i.description,
          })),
          temAlergiaMedicamentos: allergyTranslateEngToPt(
            data.allergies.isAllergicToMedicines,
          ),
          temAlergiaContrasteIodo: allergyTranslateEngToPt(
            data.allergies.isAllergicToIodine,
          ),
          temAlergiaFrutosDoMar: allergyTranslateEngToPt(
            data.allergies.isAllergicToSeafood,
          ),
        },
      }
    case 'ARQUIVOS_COMPARTILHADOS':
      return {
        anexos: [],
      }
    case 'DADOS_TRIAGEM':
      return {
        houveEdicao: data.edited,
      }
    case 'NPS_TRIAGEM':
      return {
        npsTriagem: {
          nota: data.nps.rating,
          comentario: data.nps.suggestion,
        },
      }

    default:
      return {}
  }
}
export default filterScreeningPayloadFromStep
